import { render, staticRenderFns } from "./card-details.vue?vue&type=template&id=a3d120d4&scoped=true&"
import script from "./card-details.vue?vue&type=script&lang=js&"
export * from "./card-details.vue?vue&type=script&lang=js&"
import style0 from "./card-details.vue?vue&type=style&index=0&id=a3d120d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d120d4",
  null
  
)

export default component.exports